@if (aggregatedDiagnostics(); as aggregatedDiagnostics) {
    @if (aggregatedDiagnostics.diagnostics.length > 1) {
        <app-aggregated-restaurant-diagnostic-result
            [aggregatedDiagnostics]="aggregatedDiagnostics"
            [receiverEmail]="receiverEmail()"
            [isMalouUser]="isMalouUser()"
            [publicDiagnosticUrl]="publicDiagnosticUrl()"></app-aggregated-restaurant-diagnostic-result>
    } @else {
        <app-restaurant-diagnostic-result
            [diagnostic]="aggregatedDiagnostics.diagnostics[0]"
            [receiverEmail]="receiverEmail()"
            [isMalouUser]="isMalouUser()"
            [publicDiagnosticUrl]="publicDiagnosticUrl()"></app-restaurant-diagnostic-result>
    }
}
